import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { OrdemService } from "../services/ordem.service";

@Injectable({
  providedIn: 'root'
})
export class OrdemResolver implements Resolve<boolean> {

  constructor(private service: OrdemService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class OrdemCombosResolver{

  constructor(private service: OrdemService) { }

  resolve(id:number = null): Observable<any> {
    return this.service.getListCombos(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class OrdemResolverId {

  constructor(private service: OrdemService) { }

  getById(id:number): Observable<any> {
    return this.service.getById(id);
  }
}